import { Component } from '@angular/core';
import { PATH_FORGOT_PASSWORD } from '../login.global';
import { CalvinEMRSharedModule } from '../../calvin-emr-shared/calvin-emr-shared.module';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    standalone: true,
    imports: [CalvinEMRSharedModule],
})
export class LoginPageComponent {
  /**
   * The path to the ForgotPassword page.
   */
  forgotPasswordPath = '/' + PATH_FORGOT_PASSWORD;
}
